import { render, staticRenderFns } from "./BuyteamModal.vue?vue&type=template&id=3ebb5496&"
import script from "./BuyteamModal.vue?vue&type=script&lang=js&"
export * from "./BuyteamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports